import gql from "graphql-tag";

export const GET_SHOWING_SETTINGS_QUERY = gql`
  query PrivatMeglerenShowingSettings($input: EstateInput!) {
    estate(input: $input) {
      type
      assignmentTypeMapped
      prices {
        askingPrice
      }
    }
  }
`;
